import * as types from "./mutation-types";

/**
 * Export all mutations
 */
export default {
  [types.SET_PARAM](state, payload) {
    state.links = payload;
  },

  [types.SET_MISSION_MENU](state, payload) {
    state.menu_param = payload.mission_menu.value;
  },

  [types.SET_ALCADAS](state, payload) {
    state.alcadas = payload;
  },

  [types.TOGGLE_TOUR_PRESENTATION_STATUS](state, payload) {
    const { key, value } = payload;

    state.tour_presentations[key] = value;
  },

  [types.TOGGLE_SHOW_CARD_STORES](state, payload) {
    state.component_or_element.q_menu_store_cluster = payload;
  },

  [types.TOGGLE_ALCADAS](state, payload) {
    const obj = Object.entries(payload);

    obj.forEach(([key, value]) => {
      state.show_alcadas[key] = value;
    });
  },

  [types.SET_COMPONENT_OR_ELEMENT](state, payload) {
    
    if ( !payload.key ) return;

    if ( Object.entries(payload.props).length === 0 ) return;

    Object.entries(payload.props).forEach(([key, value]) => {
      if ( !key ) return;
      state.component_or_element[payload.key][key] = value;
    });
  },
};
